import {Menu} from "../ui/layout/Menu";
import React from "react";
import {FooterCmp} from "../ui/layout/Footer";
import {PageHeader} from "../ui/ds/PageHeader";
import {Card} from "../ui/ds/Card";

export const Contact = () => {
    return (
        <>
            <Menu />
            <PageHeader title="Kontakt" subtitle="Máte dotaz? Ozvěte se nám" />
            <div className="max-w-2xl mx-auto px-4 md:px-8 py-6">
                <Card className="flex flex-col items-center text-center gap-4 py-16">
                    <span className="text-[48px]">✉️</span>
                    <h2 className="tb-h2 text-text-primary">Rádi vám pomůžeme</h2>
                    <p className="tb-body text-text-muted">V případě jakýchkoliv dotazů neváhejte nás kontaktovat:</p>
                    <a
                        href="mailto:info@tipbuddy.cz"
                        className="tb-h3 text-brand-blue hover:underline"
                    >
                        info@tipbuddy.cz
                    </a>
                </Card>
            </div>
            <FooterCmp />
        </>
    );
};
